"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var produitPriceByTarification = function produitPriceByTarification(prices, tarification, tarificationDocument) {
  if (['crossed-out', 'custom', 'professional', 'public', 'sale'].includes(tarification)) {
    return prices.find(function (p) {
      return p.type === tarification;
    });
  }

  if (!tarificationDocument) {
    return undefined;
  }

  var amount;
  var price = prices.find(function (p) {
    return p.type === tarificationDocument.id;
  });
  var pricePublic = prices.find(function (p) {
    return 'public' === p.type;
  });

  if (!price) {
    return pricePublic;
  }

  switch (tarificationDocument.scheme) {
    case 'percentage':
      {
        var priceTarification = prices.find(function (p) {
          return p.type === tarificationDocument.type;
        });

        if (priceTarification && priceTarification.amount) {
          amount = priceTarification.amount;
          return _objectSpread(_objectSpread({}, priceTarification), {}, {
            amount: amount * (tarificationDocument.percentage || 100) / 100,
            devise: tarificationDocument.devise || priceTarification.devise,
            displayMode: tarificationDocument.displayMode || priceTarification.displayMode,
            isRecurring: tarificationDocument.isRecurring || priceTarification.isRecurring
          });
        }

        if (pricePublic && pricePublic.amount) {
          return _objectSpread(_objectSpread({}, pricePublic), {}, {
            amount: pricePublic.amount * (tarificationDocument.percentage || 100) / 100,
            devise: tarificationDocument.devise || pricePublic.devise,
            displayMode: tarificationDocument.displayMode || pricePublic.displayMode,
            isRecurring: tarificationDocument.isRecurring || pricePublic.isRecurring
          });
        }

        break;
      }

    case 'graduated':
    case 'per_unit':
    case 'volume':
    default:
  }

  return tarificationDocument;
};

exports.default = produitPriceByTarification;